import { gql } from 'apollo-boost';

export const importDestroy = gql`
    mutation importDestroy($input: ImportDestroyMutationInput!) {
        importDestroy(input: $input) {
            deletedId
        }
    }
`;
